import { SeriesFunction } from '../../';

const _ = require('lodash');

function cumulativeSumSeries({series = null}) {
  let dates = series.getIndices();
  let values = series.getValues();

  const cumulativeSum = (sum => value => sum += value)(0);

  let newData = _.zip(dates, values.map(cumulativeSum));

  return new series.constructor(newData);
}

export const cumulativeSum = new SeriesFunction(
  cumulativeSumSeries,
  {
    label: 'Cumulatively Sum the Series',
    description: 'x_T = x_0 + x_1 + ... x_T-1 + x_T',
    parameters: [
      {'name': 'series', 'type': 'series'}
    ],
    maxLength: 1
  }
);